// extracted by mini-css-extract-plugin
export default {"inputForm":"Input_inputForm__Nrzwk","labelForm":"Input_labelForm__5ze89"};